import React from 'react';
import SpeciesCard from './SpeciesCard';
import MigrationChips from './MigrationChips';

const FieldJournalPanel = ({
  species,
  activeCategories,
  onCategoryClick,
  selectedSpecies,
  onSpeciesSelect,
}) => {
  return (
    <section className="absolute left-4 md:left-24 top-24 bottom-24 w-80 md:w-96 z-20 pointer-events-none">
      <div className="h-full w-full pointer-events-auto bg-surface-container/60 backdrop-blur-[20px] rounded-3xl shadow-[0px_32px_64px_rgba(0,0,0,0.6)] flex flex-col overflow-hidden">
        {/* Header */}
        <div className="p-6 pb-2">
          <h1 className="font-headline text-3xl text-primary tracking-tight">Field Journal</h1>
          <p className="font-label text-xs uppercase tracking-[0.2em] text-slate-500 mt-1">
            Active Session &mdash; {species.length} Species
          </p>
        </div>

        {/* Category Filter Chips */}
        <div className="px-6 py-4">
          <MigrationChips activeCategories={activeCategories} onCategoryClick={onCategoryClick} />
        </div>

        {/* Species List */}
        <div className="flex-1 overflow-y-auto px-6 py-2 space-y-4 hide-scrollbar">
          {species.map((s) => (
            <SpeciesCard
              key={s.id}
              species={s}
              isSelected={selectedSpecies === s.id}
              onClick={(id) => onSpeciesSelect(id === selectedSpecies ? null : id)}
            />
          ))}
          {species.length === 0 && (
            <p className="text-slate-500 text-center py-8 font-body text-sm">
              No species match your filters
            </p>
          )}
        </div>

        {/* Footer Stats */}
        <div className="p-6 bg-surface-container-lowest/40 backdrop-blur-md">
          <div className="text-xs text-slate-400 font-label">
            <span>Observed Species: {species.length}</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FieldJournalPanel;
